import { render, staticRenderFns } from "./TupleArgument.vue?vue&type=template&id=0770590c&scoped=true&"
import script from "./TupleArgument.vue?vue&type=script&lang=ts&"
export * from "./TupleArgument.vue?vue&type=script&lang=ts&"
import style0 from "./TupleArgument.vue?vue&type=style&index=0&id=0770590c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770590c",
  null
  
)

export default component.exports